import { FC } from 'react'
import {
  DetailBadge,
  DetailBadgeTone,
  DetailFeature,
  DetailFeatures,
  DetailField,
  DetailFields,
  DetailFooter,
  DetailHeader,
  DetailPanel,
} from 'app/components'
import { MedicamentoView } from '../../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

type Props = {
  data?: MedicamentoView
  isLoading?: boolean
}

/** Tom da tarja (preta/vermelha); outras ficam neutras. O texto da etiqueta é o nome da tarja. */
const tarjaTone = (tarja: string): DetailBadgeTone => {
  const value = tarja.toLowerCase()
  if (value.includes('preta')) return 'dark'
  if (value.includes('vermelha')) return 'danger'
  return 'neutral'
}

export const MedicamentoExpandedRow: FC<Props> = ({ data, isLoading }) => {
  const { t } = useT()
  if (!isLoading && !data) return null

  const criadorNome = data?.criador
    ? `${data.criador.primeiroNome ?? ''} ${data.criador.sobreNome ?? ''}`.trim()
    : ''

  return (
    <DetailPanel isLoading={isLoading} loadingLabel='Carregando detalhes do medicamento…'>
      {data && (
        <>
          <DetailHeader
            title={data.nome}
            meta={[data.codigo && `Cód. ${data.codigo}`]}
            badge={
              data.tarja && <DetailBadge tone={tarjaTone(data.tarja)}>{data.tarja}</DetailBadge>
            }
          />
          <DetailFields>
            <DetailField label={t('substancia.label')} value={data.substancia} wide />
            <DetailField label={t('concentracao.label')} value={data.concentracao} />
            <DetailField label={t('classe.label')} value={data.classe} />
            <DetailField label={t('apresentacao.label')} value={data.apresentacao} wide />
            <DetailField
              label={t('laboratorio.label')}
              value={data.laboratorio?.nome}
              detail={data.laboratorio?.cnpj && `CNPJ ${data.laboratorio.cnpj}`}
              wide
            />
          </DetailFields>
          <DetailFeatures label='Características'>
            <DetailFeature label={t('lme.label')} active={data.lme} />
            <DetailFeature label={t('sus.label')} active={data.sus} />
            <DetailFeature label={t('popular.label')} active={data.popular} />
            <DetailFeature label='Controle especial' active={data.controleEspecial} />
          </DetailFeatures>
          {criadorNome && (
            <DetailFooter>
              Cadastrado por <strong>{criadorNome}</strong>
            </DetailFooter>
          )}
        </>
      )}
    </DetailPanel>
  )
}
